<mat-form-field appearance="fill">
	<mat-label>{{ 'translation.language' | translate }}</mat-label>
	<mat-select [(ngModel)]="languageSelected">
		@for (language of enabledLanguages(); track language) {
			<mat-option [value]="language">{{ languageLabels[language] }}</mat-option>
		}
	</mat-select>
</mat-form-field>
